import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "line-item"
};
const _hoisted_2 = {
  class: "line-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_timeline = _resolveComponent("el-timeline");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_aside = _resolveComponent("el-aside");
  return _openBlock(), _createBlock(_component_el_aside, {
    width: "300px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activeTab = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "需求流程",
        name: "first"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_timeline, {
          class: "history-wrap"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.procs, (activity, index) => {
            return _openBlock(), _createBlock(_component_el_timeline_item, {
              key: index,
              type: activity.type,
              color: activity.color,
              size: activity.size,
              timestamp: activity.timestamp
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(activity.content), 1), _createElementVNode("div", _hoisted_2, _toDisplayString(activity.opterName), 1)]),
              _: 2
            }, 1032, ["type", "color", "size", "timestamp"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  });
}